<script>
import Title from "./Title.svelte";
import Footer from "./Footer.svelte";
 export let projectTitle;
 export let projectDescription;

</script>

        <article>
        <Title/>

            <section><h2>{projectTitle}</h2></section>
            <section class ='description'>{projectDescription}</section>
            <slot></slot>

        <Footer/>
        </article>


<style>
    h2{text-align: center;}

    article {
        background-color: #4D4E4F;
        display: flex;
        flex-direction: column;
        color: white;
        font-family:Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif;
        min-height: 100vh;
        width:100vw;



    }
    section{

        border-bottom: 1px solid white;

     color: white;}

     .description{flex: 1; padding:20px;}


</style>